"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginBetween = exports.progressOnText = exports.progressText = exports.progressWrapper = exports.progressContainer = void 0;

var _reactEmotion = require("react-emotion");

var progressContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("width:100%;box-sizing:border-box;display:flex;justify-content:flex-start;align-items:center;&.gridContainer{position:absolute;bottom:0px;background-color:#222933;padding:3px 6px;border-radius:3px;}");
exports.progressContainer = progressContainer;
var progressWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;align-items:center;");
exports.progressWrapper = progressWrapper;
var progressText =
/*#__PURE__*/
(0, _reactEmotion.css)("margin-left:2px;line-height:1;");
exports.progressText = progressText;
var progressOnText =
/*#__PURE__*/
(0, _reactEmotion.css)("margin-right:6px;");
exports.progressOnText = progressOnText;
var marginBetween =
/*#__PURE__*/
(0, _reactEmotion.css)("margin-right:8px;");
exports.marginBetween = marginBetween;